
import { Circle } from "lucide-react";

interface CircularProgressProps {
  progress: number;
  currentSize?: number;
  totalSize?: number;
  size?: number;
  strokeWidth?: number;
}

export function CircularProgress({ 
  progress, 
  currentSize, 
  totalSize,
  size = 240,
  strokeWidth = 8 
}: CircularProgressProps) {
  const radius = (size / 2) - strokeWidth;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  const formatSize = (bytes: number): string => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${(bytes / Math.pow(k, i)).toFixed(1)} ${sizes[i]}`;
  };

  return (
    <div className="relative flex flex-col items-center justify-center w-full space-y-6">
      <div className="relative flex items-center justify-center w-full h-[300px]">
        <svg className="transform -rotate-90" width={size} height={size}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="rgba(255, 255, 255, 0.1)"
            strokeWidth={strokeWidth}
            fill="none"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="#00F5D0"
            strokeWidth={strokeWidth}
            fill="none"
            strokeLinecap="round"
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: strokeDashoffset,
              transition: "all 0.3s ease-out"
            }}
          />
        </svg>
        <div className="absolute flex flex-col items-center justify-center space-y-2">
          <span className="text-4xl font-bold text-white" style={{
            transition: "all 0.3s ease-out"
          }}>
            {progress.toFixed(1)}%
          </span>
          {currentSize !== undefined && totalSize !== undefined && (
            <span className="text-sm text-white/80">
              {formatSize(Math.round((totalSize / 100) * progress))} de {formatSize(totalSize)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
